<template>
    <div class="p-3">
        <div class="row">
            <div class="col-md-12">
                <h2>{{transEdit('choose-substitute-for-day')}}</h2>
                <hr>
                <h4>{{getDate(schedules[0].start)}}</h4>
                <hr>
                <h5 class="text-danger">{{transEdit('choose-substitute-for-day-text')}}</h5>
                <div class="form-group">
                    <label>{{transEdit('substitute')}}</label>
                    <select class="form-control" id="therapist-select2" required></select>
                </div>
                <div >
                    <button class="btn btn-primary" @click="changeTherapist" :disabled="selectedTherapist < 1"><i class="fa fa-check"></i> {{transEdit('accept')}}</button>
                    <button class="btn btn-dark" @click="$emit('close')"><i class="fa fa-ban"></i> {{transEdit('cancel')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
    export default {
        name: "SubstituteForDayModal",
        props: ['schedules'],
        data(){
            return {
                selectedTherapist: 0,
                therapists: null,
            }
        },
        methods: {
            changeTherapist(){
                let scheduleIdArray = this.schedules.map(element => element.id);
                if(this.selectedTherapist){
                    axios.post('/therapists/substitute', {
                        'schedule_id': scheduleIdArray,
                        'therapist_id': this.selectedTherapist
                    }).then((res) => {
                        if(!res.error) {
                            Vue.toasted.success(res.data.data);
                            this.$emit('close');
                        } else {
                            Vue.toasted.error(res.data[1]);
                        }
                    });
                }
            },
            getDate(dateString){
                return moment(dateString).format('YYYY-MM-DD');
            },
            getDateTime(dateString){
                return moment(dateString).format('YYYY-MM-DD HH:mm');
            },
            getTime(dateString){
                return moment(dateString).format('HH:mm')
            },
        },
        mounted(){
            let self = this;
            $('#therapist-select2').select2({
                ajax: {
                    url: '/therapists/autocomplete',
                    dataType: 'json',
                    delay: 500,
                    processResults: function (data) {
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    id: item.id,
                                    text: item.value
                                }
                            })
                        };
                    }
                },
            })
            .on('select2:select', function (e) {
                self.selectedTherapist = e.params.data.id;
            });
        }
    }
</script>

<style scoped>

</style>
